import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f036f11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-map me-1",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close",
  "aria-label": "close modal"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "overlay__container" }
const _hoisted_7 = { class: "overlay__title" }
const _hoisted_8 = { class: "overlay__map" }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectorMap = _resolveComponent("SectorMap")!
  const _component_RegionTeaser = _resolveComponent("RegionTeaser")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-light text-primary regions-grid__button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showMap = true;})
      }, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.ticket.configuration.Show-Map')), 1)
      ]),
      (_ctx.showMap)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn overlay__close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMap = false))
            }, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.translate('shop.ticket.configuration.Regions-Map')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_SectorMap)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.showError)
      ? (_openBlock(), _createBlock(_TransitionGroup, {
          key: 0,
          tag: "div",
          class: "regions-grid",
          name: "fade",
          appear: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "regions-grid__item",
                key: region
              }, [
                (_openBlock(), _createBlock(_component_RegionTeaser, {
                  key: region.id,
                  isMainRegion: region.isMainRegion,
                  name: region.name,
                  text: region.text,
                  id: region.id,
                  image: region.image,
                  isSelected: _ctx.selectedRegion.id === region.id,
                  onOnSelect: _ctx.onChangeRegion
                }, null, 8, ["isMainRegion", "name", "text", "id", "image", "isSelected", "onOnSelect"]))
              ]))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_Error, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"])
        ]))
  ], 64))
}